import { nieswiadomyUmyslChapters } from './content';
export const nieswiadomyUmyslScoring = nieswiadomyUmyslChapters.filter((chapter) => /punkt|scor/i.test(chapter.title));
